<template>
  <div id="content">
    <popup v-show="hasPopup"
           :popup-type="getPopupType"
           :popup-action="getPopupAction"
           @popup-action="executePopupAction" />
    <div class="inner">
      <p class="buttons">
        <a v-if="$_deleteActionAllowed && !isGlobal" class="btn btn_action btn_delete" :title="'Smazat' | translate"
           @click.prevent.stop="deleteEntity(true, {path: 'landingPage'})" v-translate>
          Smazat
        </a>
      </p>
      <h1>
        Landing page
        <span v-if="!loading">| {{ entity.name_operator || 'globální' }}</span>
        <span v-if="willOverride">&rarr; {{ entity.name_target_operator }}</span>
      </h1>
    </div>
    <div class="inner_white">
      <section>
        <text-input id="title"
                    :required="true"
                    v-model="entity.title"
                    ref="titleref"
        >
          <translate class="translate">Nadpis</translate>
        </text-input>
        <html-editor
            id="body"
            name="body"
            :custom-toolbar="customToolbar"
            :body="entity.body"
            @newVal="entity.body = arguments[0]"
            ref="bodyref"
        >
          <translate class="translate">Tělo</translate>
        </html-editor>
      </section>
      <section class="buttons">
        <p>
          <router-link :to="{ name: 'landingPage' }" class="btn btn_back btn_seznam" v-translate>Zpět
          </router-link>
          <input
              type="submit" :value="'Uložit' | translate"
              :class="['btn']"
              @click.prevent.stop="submitForm()">
        </p>
      </section>
    </div>
  </div>
</template>

<script>
import HtmlEditor from "../../common/HtmlEditor.vue";
import detailActions from "../../mixins/detail-actions";

export default {
  name: 'LandingPageForm',
  components: { HtmlEditor },
  created(LandingPageService) {
    this.entityService = LandingPageService
    this.getEntity()
  },
  mixins: [detailActions],
  data() {
    return {
      loading: true,
      entity: {},
      entityName: 'landingPage',
      customToolbar: [
        [{ header: [2, 3, 4] }],
        ["bold", "italic", "underline"],
        ["color"],
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
        ],
        [{ list: 'bullet' }, { list: 'ordered' }],
        ["link"],
        ["clean"]
      ],
      updateFields: [
        'title',
        'body',
      ],
    }
  },
  methods: {
    _afterGetEntityActions() {
      this.loading = false
    },
    _afterUpdateEntityActions() {
      this.redirect('landingPage')
    },
  },
  computed: {
    isGlobal() {
      return !(this.entity.name_operator)
    },
    willOverride() {
      return (this.entity.name_operator || '') !== (this.entity.name_target_operator || '')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/landingPage/LandingPageForm.vue